import React from "react";
import { useQuery } from "@apollo/client";
import CardIssuer from "enums/CardIssuer";
import AccountType from "enums/AccountType";
import { GET_REWARDS_BANK_PROGRAM } from "graphql/cardProgram";
import type { CardProgram } from "hooks/useCardPrograms";
import BankIntegration from "../BankIntegration";
import PlaidRewardsBankLink from "./PlaidRewardsBankLink";

export interface RewardsBankLinkProps {
  accountType?: AccountType;
  renderTrigger: (
    handleOpenAddBank: () => void,
    loading: boolean,
  ) => React.ReactNode;
  onBankAdded?: (accountId: string) => void;
  refetchBankAccounts: () => void;
  onActiveChange?: (active: boolean) => void;
}

// The server names the program the rewards bank links under, so its issuer picks the flow on both sides
const RewardsBankLink: React.FC<RewardsBankLinkProps> = (props) => {
  const { data, loading } = useQuery<{
    rewardsBankProgram: CardProgram | null;
  }>(GET_REWARDS_BANK_PROGRAM);
  if (loading || !data)
    return <>{props.renderTrigger(() => undefined, true)}</>;
  const program = data.rewardsBankProgram ?? undefined;
  if (program?.issuer === CardIssuer.HIGHNOTE) {
    return <PlaidRewardsBankLink {...props} />;
  }
  return <BankIntegration {...props} program={program} />;
};

export default RewardsBankLink;
